import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';
import Swiper from 'swiper';

function mostComparedCarousel() {
  const carousel = document.querySelector('.most-compared__carousel');

  if (carousel) {
    new Swiper(carousel, {
      slidesPerView: 1.4,
      spaceBetween: 25,
      watchOverflow: true,
      loop: false,

      scrollbar: {
        el: carousel.querySelector('.swiper-scrollbar'),
        draggable: true,
      },

      navigation: {
        prevEl: carousel.querySelector('.swiper-button-prev'),
        nextEl: carousel.querySelector('.swiper-button-next'),
      },

      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 25,
        },
      },
    });
  }
}

function maybeTriggerComparison(ids) {
  const instructionsDiv = document.querySelector('.compareInstructions');

  if (ids && 1 < ids.length) {
    const resultsDiv = document.querySelector('.compareResultsHtml');
    const resultsContainer = document.querySelector('.compare-results');
    const loader = document.querySelector('.comparisonLoaderWrapper');
    if (resultsDiv && resultsContainer) {
      //start the loading
      instructionsDiv.style.display = 'none';

      if (!resultsContainer.classList.contains('isLoading')) {
        resultsContainer.classList.add('isLoading');
        loader.focus();
      }
      fetch(theme.rest_url + 'programs/html/compare?ids=' + ids.join(',')) // eslint-disable-line
        .then((response) => {
          if (!response.ok) {
            return _x(
              'Something went wrong with the request!',
              'JS fetch error',
              'vtx'
            );
          }
          return response.json();
        })
        .then((response) => {
          resultsDiv.innerHTML = response;
          //end the loading
          if (resultsContainer.classList.contains('isLoading')) {
            resultsContainer.classList.remove('isLoading');
          }
          setTimeout(function () {
            resultsDiv.focus();
          }, 300);
        });
    }
  } else {
    instructionsDiv.style.display = 'block';
  }
}
domReady(() => {
  const TomSelectObj = [];
  const compareSelects = document.querySelectorAll('.compareSelection');
  if (compareSelects) {
    function checkSelected() {
      const allIds = [];
      compareSelects.forEach((selectEle) => {
        if (selectEle.value) allIds.push(selectEle.value);
      });
      if (allIds) {
        maybeTriggerComparison(allIds);
      }
    }
    compareSelects.forEach((element) => {
      const tmpObj = new TomSelect(element, {
        create: false,
      });
      TomSelectObj.push(tmpObj);
      element.addEventListener('change', checkSelected);
    });
    const urlParams = new URLSearchParams(window.location.search);
    const progId = urlParams.get('prog_id');
    if (
      progId &&
      compareSelects[0] &&
      compareSelects[0].querySelector('option[value="' + progId + '"]') &&
      TomSelectObj[0]
    ) {
      TomSelectObj[0].setValue(progId);
    }
  }
  const compareButtons = document.querySelectorAll('.triggerCompare');
  if (compareButtons) {
    compareButtons.forEach((element) => {
      element.addEventListener('click', () => {
        const programs = element.getAttribute('data-programs');
        if (programs) {
          const orderedIds = programs.split(',');
          maybeTriggerComparison(orderedIds);
          if (compareSelects) {
            for (let i = 0; i < orderedIds.length; i++) {
              if (
                compareSelects[i] &&
                compareSelects[i].querySelector(
                  'option[value="' + orderedIds[i] + '"]'
                ) &&
                TomSelectObj[i]
              ) {
                TomSelectObj[i].setValue(orderedIds[i]);
              }
            }
          }
        }
      });
    });
  }

  mostComparedCarousel();
});
